import React from 'react';

/**
 * LoadingSpinner — centered spinner with optional label.
 * size: 'sm' | 'md' | 'lg'
 * variant: 'border' | 'grow'
 * fullPage: boolean — covers entire viewport
 */
const LoadingSpinner = ({
  size = 'md',
  variant = 'border',
  label = 'Chargement...',
  fullPage = false,
  className = '',
}) => {
  const spinnerSize = size === 'sm' ? 'spinner-border-sm' : '';
  const spinnerClass = [`spinner-${variant}`, spinnerSize, className].filter(Boolean).join(' ');

const spinner = (
    <div
      className="d-flex flex-column align-items-center justify-content-center gap-2"
      role="status"
      aria-label={label}
    >
      <div
        className={spinnerClass}
        style={{ color: 'var(--color-primary)' }}
        aria-hidden="true"
      />
      {size !== 'sm' && (
        <span style={{ color: 'var(--color-text-muted)', fontSize: 'var(--text-sm)' }}>
          {label}
        </span>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--color-overlay)',
          zIndex: 'var(--z-modal)',
        }}
      >
        {spinner}
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center justify-content-center p-4">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
